import service from '@/utils/https';

export const getAssetsList = (data) => {
  return service.get('/api/app/v1/assets', { params: data });
};

export const createAsset = (data) => {
  return service.post('/api/app/v1/assets', data);
};

export const updateAsset = (id, data) => {
  return service.put(`/api/app/v1/assets/${id}`, data);
};

export const deleteAsset = (id) => {
  return service.delete(`/api/app/v1/assets/${id}`);
};

export const importAssetsCsv = (data) => {
  return service.post('/api/app/v1/assets/import-csv', data);
};
